/**
 * Banner About
 */

export default function BannerAbout() {
    const selectors = {
        'wrapper' : '.about-banner',
    };

    this.init = () => {
        this.photoswipe();
    };

    this.photoswipe = () => {
        jQuery(selectors.wrapper).find('.video-popup').on('click', function (event) {
            event.preventDefault();
            var __btn_click = jQuery(this);

            var _openPhotoSwipe = function () {
                var pswpElement = document.querySelectorAll('.pswp')[0];

                // build items array
                var items = jQuery(".pswp-video-banner").data("video-banner")

                // define options (if needed)
                var __pswp_options = {
                    // history & focus options are disabled on CodePen
                    bgOpacity: 0.8,
                    history: false,
                    focus: false,
                    pinchToClose: false,
                    closeOnScroll: false,
                    closeOnVerticalDrag: false,
                    
                };
                __pswp_options.index = __btn_click.parent().children().index(__btn_click);

                var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, __pswp_options);

                gallery.init();

            };
            _openPhotoSwipe();

        });
    }
}
